(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(html, ms) {
    var t = document.getElementById('KidultToast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, ms || 3200);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) {
      var t = document.getElementById('KidultToast');
      if (t) t.classList.remove('is-visible');
    }
  });

  function updateCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        });
        document.querySelectorAll('[data-cart-label]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.k-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var form = input.closest('form');
    clearTimeout(form._t);
    form._t = setTimeout(function () { form.submit(); }, 450);
  });

  /* ---------- AJAX add to cart (with clear feedback) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-kidult-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn && btn.querySelector('[data-label]');
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (label) label.textContent = 'Adding...';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        var item = res.data || {};
        if (btn) btn.classList.add('is-added');
        if (label) label.textContent = 'Added ✓';
        return updateCartCount().then(function (cart) {
          var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" class="k-toast__img">' : '';
          var title = String(item.product_title || 'Item').replace(/</g, '&lt;');
          toast(
            '<div class="k-toast__row">' + img +
              '<div class="k-toast__msg"><strong>Added to cart ✓</strong><span>' + title + '</span></div>' +
              '<button type="button" class="k-toast__x" data-toast-close aria-label="Close">×</button>' +
            '</div>' +
            '<div class="k-toast__actions">' +
              '<a href="' + root + 'cart" class="k-toast__btn">View cart (' + cart.item_count + ')</a>' +
              '<a href="' + root + 'checkout" class="k-toast__btn k-toast__btn--primary">Checkout</a>' +
            '</div>',
            6000
          );
        });
      })
      .catch(function (err) {
        toast('<div class="k-toast__row"><div class="k-toast__msg"><strong>Sorry, could not add to cart</strong><span>' + String(err.message).replace(/</g, '&lt;') + '</span></div><button type="button" class="k-toast__x" data-toast-close aria-label="Close">×</button></div>', 5000);
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        setTimeout(function () {
          if (btn) btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 2200);
      });
  });

  /* ---------- Product page ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '₹{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  document.querySelectorAll('[data-product]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = section.getAttribute('data-money-format');
    var form = section.querySelector('form[data-kidult-add]');
    var idInput = form && form.querySelector('input[name="id"]');
    var addBtn = form && form.querySelector('[data-add-button]');
    var addLabel = addBtn && addBtn.querySelector('[data-label]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var offEl = section.querySelector('[data-off]');
    var stockEl = section.querySelector('[data-stock]');

    function selected() {
      return Array.prototype.map.call(section.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        var legendValue = group.querySelector('[data-option-value]');
        if (checked && legendValue) legendValue.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.textContent = onSale ? money(variant.compare_at_price, moneyFormat) : ''; compareEl.hidden = !onSale; }
      if (offEl) {
        offEl.hidden = !onSale;
        if (onSale) offEl.textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + '% OFF';
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In stock, ready to ship' : 'Sold out';
        stockEl.classList.toggle('is-out', !variant.available);
      }
      if (variant.featured_media) {
        var thumb = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    section.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
  });

  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();